import axios from 'axios';
import { getAuthHeaders } from './authHeaders';

axios.interceptors.request.use((config) => {
  const authHeaders = getAuthHeaders();
  if (authHeaders.Authorization) {
    config.headers = config.headers || {};
    if (typeof config.headers.set === 'function') {
      config.headers.set('Authorization', authHeaders.Authorization);
    } else {
      config.headers.Authorization = authHeaders.Authorization;
    }
  }
  return config;
});

// Let react-admin authProvider.checkError handle 401 logout — avoid hard reload loops here.
axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default axios;
